<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T12:42:59+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Show cards with case studies
@Last modified by:   tom
@Last modified time: 2019-06-12T23:16:22+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">

  <!-- full width background -->
  <section id="puck-solutions">
    <!-- contained content -->
    <div class="container">
      <div class="header ">
        <icon class="text-primary" name="shield-alt" scale="2"/>
        <h1 class="text-primary" v-html="$t('solutions.consumer.title')" />
        <span v-html="$t('solutions.consumer.payload')"/>
      </div>

      <!-- pane around all cards, check if we need to show arrows when mouser hover -->
      <div id="casespane" @mouseover="isTabBoxLR()">

        <!-- the scroll arrow buttons appear when first/last case is out of full sight -->
        <div v-show="isOffLeft" id="toleftpanel" @click="scrollDelta(-230)">
          <div id="leftangle"/>
        </div>
        <div v-show="isOffRight" id="torightpanel" @click="scrollDelta(230)">
          <div id="rightangle"/>
        </div>

        <!-- show borders of the casespane -->
        <div id="leftrowshadow"/>
        <div id="rightrowshadow"/>

        <!-- render the actual cards -->
        <div
          id="caserow"
          class="bg-secondary"
          @scroll="isTabBoxLR()">
          <div
            v-for="f in nrCases"
            :key="f"
            :id="'case_' + f"
            class="case-card bg-white">
            <div @click="scrollToCase(f)">
              <div
                class="card-header"
                v-html="$t('solutions.consumer.' + f + '.label')"/>
              <lzimg
                :src="assetUrl('img/solutions/'+ $t('solutions.consumer.' + f + '._img'))"
                class="card-image"
                fluid
                width="700"
                height="350" />
            </div>
            <router-link :to="`/consumers#index-${f}`" class="card-link">
              {{ $t('def.read_more') }}...
            </router-link>
          </div> <!-- .casecard -->

        </div>
      </div>  <!-- casespane -->
      <blockquote
        v-html="$t('solutions.consumer.quote')" />
    </div> <!-- container -->
  </section>

</template>

<script>
import invokeScrollEvent from '@/components/_shared/invokeScrollEvent'

export default {
  name: 'SolutionSlider',
  data () {
    return {
      nrCases: 5, // the nr of cases to show
      isOffRight: false, // the position of right/left sensor elements on the tab bar
      isOffLeft: false,
      allLazyloaded: false // to test if we have invoked scroll for ALL images in the pane
    }
  },
  methods: {
    // find position of first and last case and see if it is scrolled out of window
    isTabBoxLR: function () {
      //  note: we need @scroll="isTabBoxLR()" on the containing <div> to launch this method
      // check if first case is to left of parent position
      const p = document.querySelector('#caserow').getBoundingClientRect().left
      const l = document.querySelector('#case_1').getBoundingClientRect().left
      this.isOffLeft = l - p < 0

      // check if most of last case is beyond the parent positon + width of container
      // console.log(`nrCases ${this.nrCases}`)
      const r = document.querySelector('#case_' + this.nrCases).getBoundingClientRect().right
      const w = document.querySelector('#caserow').getBoundingClientRect().right - p

      this.isOffRight = r > p + w
      // as long as we did not reach the most right position, we need to make sure all images are lazyloaded
      if (this.isOffRight && !this.allLazyloaded) {
        invokeScrollEvent('Scroll in Cases')
      } else {
        this.allLazyloaded = true
      }
      // console.log("Parent L=" + p + ", Case 1 L = " + l + ", W = " + w + ", R = " + r + ", P+W = " + (p + w))
    },
    // scroll to a case
    scrollToCase (t) {
      // find the active tab by it's class
      var caselist = document.getElementsByClassName('case-card')
      // check if tab is already active on this page, if so, scroll to it
      if (caselist.length > 0) {
        // using https://rigor789.github.io/vue-scrollto/#/
        // console.log(`Scroll to card nr ${t}`)
        this.$scrollTo('#case_' + t, 400, { x: true, y: false, offset: -60, container: '#caserow' })
      }
      // for laxy loading, we invoke scroll event (ignore Lint Error... it seem to work ok)
      invokeScrollEvent('Scroll to Case Studies')
    },
    // scroll whole card row over 'd' pixels
    scrollDelta (d) {
      // we scroll a delta by increasing or decreasing the offset of the first card
      // find position of the first case, subtracting position of parent
      const p = document.querySelector('#caserow').getBoundingClientRect().left
      const l = document.querySelector('#case_1').getBoundingClientRect().left
      const scrollDelta = -l + p + d
      // console.log('before scroll: parent = ' + p + ', left = ' + l + ', scroll=' + scrollDelta)
      this.$scrollTo('#case_1', 400, { x: true, y: false, offset: scrollDelta, container: '#caserow' })
    }
  }
}
</script>

<style lang="scss" scoped>

  #puck-solutions {
    #casespane {
      position: relative; // to allows absolute position of arrows

      // vertical shadows to appear to move the cases under while horizontal scrolling
      #leftrowshadow,
      #rightrowshadow {
        width: 10px;
        height: 100%;
        z-index: 5;
        position: absolute;
      }
      #leftrowshadow {
        -webkit-box-shadow: inset 6px 0px 5px 0px rgba(0,0,0,0.56);
        -moz-box-shadow:    inset 6px 0px 5px 0px rgba(0,0,0,0.56);
        box-shadow:         inset 6px 0px 5px 0px rgba(0,0,0,0.56);
      }
      #rightrowshadow {
        right: 0;
        -webkit-box-shadow: inset -6px 0px 5px 0px rgba(0,0,0,0.56);
        -moz-box-shadow:    inset -6px 0px 5px 0px rgba(0,0,0,0.56);
        box-shadow:         inset -6px 0px 5px 0px rgba(0,0,0,0.56);
      }

      // the panels with L/R arrows to show if user scrolls tab of screen
      #toleftpanel,
      #torightpanel {
        position: absolute;
        padding-top: 200px;
        height: 100%;
        width: 40px;
        top: 0;
        color: $dark;
        opacity: 0.5;
        cursor: pointer;
        z-index: 10;
      }
      #torightpanel {
        right: 0;
        padding-left: 17px; // arrows not fully even
      }
      #toleftpanel {
        left: 0;
        padding-right: 15px;
      }
      #toleftpanel:hover,
      #torightpanel:hover {
        opacity: 1;
      }
      // the arrows, with inline .svg
      #rightangle,
      #leftangle {
        height: 95%;
        width: 20px;
        position: absolute;
        top: 0;
        background-color: $dark;
        background-position: 0, 20px;
        background-repeat: no-repeat;
      }
      #rightangle {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
      }
      #leftangle {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
      }

      // the scroll panel holding the case cards
      #caserow {
        padding: 10px;
        margin-top: 15px;
      //  height: 425px;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden; /* <-- hide vertical scrollbar */
        border:    1px solid $secondaryDark;
        box-shadow:         inset 0px 6px 5px 0px rgba(0,0,0,0.56);
        -moz-box-shadow:    inset 0px 6px 5px 0px rgba(0,0,0,0.56);
        -webkit-box-shadow: inset 0px 6px 5px 0px rgba(0,0,0,0.56);
      }
      .case-card {
        width: 220px;
      //  height: 390px;
        margin: 0 10px;
        display: inline-block;
        -webkit-box-shadow: 6px 6px 2px 0px rgba(0,0,0,0.58);
        -moz-box-shadow: 6px 6px 2px 0px rgba(0,0,0,0.58);
        box-shadow: 6px 6px 2px 0px rgba(0,0,0,0.58);
        cursor: pointer;

        .card-header {
          // height: 80px;
          padding: 0.5em;
          font-variant: all-small-caps;
          text-align: center;
        }
        .card-link {
          padding: 0.3em;
          font-size: 1em;
          text-align: center;
          width: 100%;
          display: inline-block;
        }

        .card-img {
          border-top: 1px solid $primaryDark;
          border-bottom: 1px solid $primaryDark;
        }
        .card-body {
          display: block;
          padding: 0 10px;
          margin-bottom: 10px;
          overflow: hidden;
          white-space: normal;
          height: 230px;
          h6 {
            margin: 10px 0 5px 0;
            padding: 0;
            font-weight: bold;
          }

        }
      }
    }
    blockquote {
    //  color: $primaryWhite;
      text-align: center;
    }
  }
  @media (max-width:600px) {

  }

  @media (min-width:600px) {
    #puck-solutions {
      #casespane {
        #toleftpanel,
        #torightpanel {
          background: none;
        }
        #rightangle,
        #leftangle {
          background-color: transparent;
        }
        #toleftpanel {
          left: -48px;
        }
        #torightpanel {
          right: -48px;
        }
      }
    }
  }

</style>
